import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, vShow as _vShow, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    id: "campaigns",
    class: "flex"
};
const _hoisted_2 = { class: "admin-form panel-form" };
const _hoisted_3 = { class: "form-group" };
const _hoisted_4 = { class: "mt-2" };
const _hoisted_5 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_6 = { class: "mt-2" };
const _hoisted_7 = ["value"];
const _hoisted_8 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_9 = { class: "mt-2" };
const _hoisted_10 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_11 = { class: "mt-2" };
const _hoisted_12 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_13 = { class: "flex items-center" };
const _hoisted_14 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_15 = { class: "flex items-center" };
const _hoisted_16 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_17 = { class: "flex items-center" };
const _hoisted_18 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_19 = { class: "flex items-center" };
const _hoisted_20 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_21 = { class: "admin-form panel-form" };
const _hoisted_22 = { class: "form-group relative" };
const _hoisted_23 = { class: "flex pb-4 justify-end xl:pb-0 xl:absolute xl:top-0 xl:right-0" };
const _hoisted_24 = {
    key: 0,
    class: "col-span-4"
};
const _hoisted_25 = ["for"];
const _hoisted_26 = { class: "flex mt-2" };
const _hoisted_27 = ["name", "id", "onUpdate:modelValue"];
const _hoisted_28 = ["value"];
const _hoisted_29 = ["onClick"];
const _hoisted_30 = ["aria-labelledby"];
const _hoisted_31 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_32 = {
    key: 1,
    class: "border-slate-300 my-4"
};
const _hoisted_33 = {
    key: 1,
    class: "col-span-6"
};
const _hoisted_34 = { class: "admin-form panel-form" };
const _hoisted_35 = { class: "form-group relative" };
const _hoisted_36 = { class: "flex pb-4 justify-end xl:pb-0 xl:absolute xl:top-0 xl:right-0" };
const _hoisted_37 = {
    key: 0,
    class: "col-span-4"
};
const _hoisted_38 = ["for"];
const _hoisted_39 = { class: "flex mt-2" };
const _hoisted_40 = ["name", "id", "onUpdate:modelValue"];
const _hoisted_41 = ["onClick"];
const _hoisted_42 = ["aria-labelledby"];
const _hoisted_43 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_44 = ["for"];
const _hoisted_45 = { class: "mt-2" };
const _hoisted_46 = ["name", "id", "onUpdate:modelValue"];
const _hoisted_47 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_48 = ["for"];
const _hoisted_49 = { class: "mt-2" };
const _hoisted_50 = ["name", "id", "onUpdate:modelValue"];
const _hoisted_51 = ["value"];
const _hoisted_52 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_53 = { key: 3 };
const _hoisted_54 = ["for"];
const _hoisted_55 = { class: "mt-2" };
const _hoisted_56 = ["name", "id", "onUpdate:modelValue"];
const _hoisted_57 = ["value"];
const _hoisted_58 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_59 = ["for"];
const _hoisted_60 = { class: "mt-2" };
const _hoisted_61 = ["name", "id", "onUpdate:modelValue"];
const _hoisted_62 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_63 = ["for"];
const _hoisted_64 = { class: "mt-2" };
const _hoisted_65 = ["name", "id", "onUpdate:modelValue"];
const _hoisted_66 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_67 = {
    key: 4,
    class: "border-slate-300 my-4"
};
const _hoisted_68 = {
    key: 1,
    class: "col-span-6"
};
const _hoisted_69 = { class: "admin-form panel-form" };
const _hoisted_70 = { class: "form-group relative" };
const _hoisted_71 = { class: "flex pb-4 justify-end xl:pb-0 xl:absolute xl:top-0 xl:right-0" };
const _hoisted_72 = {
    key: 0,
    class: "col-span-4"
};
const _hoisted_73 = ["for"];
const _hoisted_74 = { class: "flex mt-2" };
const _hoisted_75 = ["name", "id", "onUpdate:modelValue"];
const _hoisted_76 = ["value"];
const _hoisted_77 = ["disabled", "onClick"];
const _hoisted_78 = ["aria-labelledby"];
const _hoisted_79 = ["disabled", "onClick"];
const _hoisted_80 = ["aria-labelledby"];
const _hoisted_81 = ["onClick"];
const _hoisted_82 = ["aria-labelledby"];
const _hoisted_83 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_84 = ["for"];
const _hoisted_85 = { class: "mt-2" };
const _hoisted_86 = ["name", "id", "onUpdate:modelValue"];
const _hoisted_87 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_88 = ["for"];
const _hoisted_89 = { class: "mt-2" };
const _hoisted_90 = ["name", "id", "onUpdate:modelValue"];
const _hoisted_91 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_92 = {
    key: 3,
    class: "border-slate-300 my-4"
};
const _hoisted_93 = {
    key: 1,
    class: "col-span-6"
};
const _hoisted_94 = { class: "admin-form panel-form" };
const _hoisted_95 = { class: "form-group" };
const _hoisted_96 = { class: "mt-2" };
const _hoisted_97 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_98 = { class: "admin-form panel-form" };
const _hoisted_99 = { class: "form-group relative" };
const _hoisted_100 = { class: "flex pb-4 justify-end xl:pb-0 xl:absolute xl:top-0 xl:right-0" };
const _hoisted_101 = {
    key: 0,
    class: "col-span-4"
};
const _hoisted_102 = ["for"];
const _hoisted_103 = { class: "flex mt-2" };
const _hoisted_104 = ["name", "id", "onUpdate:modelValue"];
const _hoisted_105 = ["value"];
const _hoisted_106 = ["onClick"];
const _hoisted_107 = ["aria-labelledby"];
const _hoisted_108 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_109 = ["for"];
const _hoisted_110 = { class: "mt-2" };
const _hoisted_111 = ["name", "id", "onUpdate:modelValue"];
const _hoisted_112 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_113 = ["for"];
const _hoisted_114 = { class: "mt-2" };
const _hoisted_115 = ["name", "id", "onUpdate:modelValue"];
const _hoisted_116 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_117 = ["for"];
const _hoisted_118 = { class: "mt-2" };
const _hoisted_119 = ["name", "id", "onUpdate:modelValue"];
const _hoisted_120 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_121 = ["for"];
const _hoisted_122 = { class: "mt-2" };
const _hoisted_123 = ["name", "id", "onUpdate:modelValue"];
const _hoisted_124 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_125 = {
    key: 5,
    class: "border-slate-300 my-4"
};
const _hoisted_126 = {
    key: 1,
    class: "col-span-6"
};
const _hoisted_127 = { class: "admin-form panel-form" };
const _hoisted_128 = { class: "form-group" };
const _hoisted_129 = { class: "mt-2" };
const _hoisted_130 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_131 = { class: "admin-form panel-form" };
const _hoisted_132 = { class: "form-group" };
const _hoisted_133 = { class: "mt-2" };
const _hoisted_134 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_135 = { class: "mt-2" };
const _hoisted_136 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_137 = { class: "mt-2" };
const _hoisted_138 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_139 = { class: "flex px-1" };
const _hoisted_140 = { class: "flex-1" };
const _hoisted_141 = {
    key: 0,
    class: "success-message"
};
const _hoisted_142 = {
    key: 1,
    class: "error-message"
};
const _hoisted_143 = ["disabled", "aria-disabled"];
const _hoisted_144 = {
    class: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Loading = _resolveComponent("Loading");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.report.title), 1),
            _createElementVNode("nav", null, [
                _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.report.navigation.goBack && _ctx.report.navigation.goBack(...args))),
                    type: "button",
                    class: "alt"
                }, "Go Back")
            ])
        ]),
        _cache[76] || (_cache[76] = _createElementVNode("div", { class: "top-help-block" }, [
            _createElementVNode("div", null, [
                _createElementVNode("span", { class: "text-brand-600" }, "*"),
                _createTextVNode(" denotes required field ")
            ])
        ], -1)),
        (_ctx.report.isLoaded())
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                action: "#",
                method: "post",
                enctype: "multipart/form-data",
                onSubmit: _cache[18] || (_cache[18] = _withModifiers(($event) => (_ctx.report.submitReport()), ["prevent"]))
            }, [
                _createElementVNode("section", _hoisted_2, [
                    _cache[31] || (_cache[31] = _createElementVNode("aside", null, [
                        _createElementVNode("h2", { class: "font-medium text-lg" }, "Report Information"),
                        _createElementVNode("p", null, " Settings pertaining to how a report is rendered and the report information. When a report is rendered two primary sources of information are available, the report data (individual rows of information based on the report query) and the report totals (the counts/sums of columns on the report). Columns are configured by the report selects and can be configured to count and sum relevant columns (please note these columns are limited to numeric data types only). ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["col-span-6 xl:col-span-2", { 'form-control-error': _ctx.report.fieldHasErrors('name') }])
                        }, [
                            _cache[19] || (_cache[19] = _createElementVNode("label", { for: "name" }, [
                                _createTextVNode("Name"),
                                _createElementVNode("span", { class: "req-asterisk" }, "*")
                            ], -1)),
                            _createElementVNode("div", _hoisted_4, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    name: "name",
                                    id: "name",
                                    required: "",
                                    "aria-required": "true",
                                    autocomplete: "off",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.report.data.name) = $event))
                                }, null, 512), [
                                    [_vModelText, _ctx.report.data.name]
                                ])
                            ]),
                            (_ctx.report.fieldHasErrors('name'))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.report.getFieldError('name')), 1))
                                : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(["col-span-6 xl:col-span-2", { 'form-control-error': _ctx.report.fieldHasErrors('connection') }])
                        }, [
                            _cache[21] || (_cache[21] = _createElementVNode("label", { for: "connection" }, [
                                _createTextVNode("Connection"),
                                _createElementVNode("span", { class: "req-asterisk" }, "*")
                            ], -1)),
                            _createElementVNode("div", _hoisted_6, [
                                _withDirectives(_createElementVNode("select", {
                                    name: "connection",
                                    id: "connection",
                                    required: "",
                                    "aria-required": "true",
                                    autocomplete: "off",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.report.data.connection) = $event))
                                }, [
                                    _cache[20] || (_cache[20] = _createElementVNode("option", { value: null }, "Select Connection", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.connections, (connection) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            value: connection.value
                                        }, _toDisplayString(connection.name), 9, _hoisted_7));
                                    }), 256))
                                ], 512), [
                                    [_vModelSelect, _ctx.report.data.connection]
                                ])
                            ]),
                            (_ctx.report.fieldHasErrors('connection'))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.report.getFieldError('connection')), 1))
                                : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.report.fieldHasErrors('description') }])
                        }, [
                            _cache[22] || (_cache[22] = _createElementVNode("label", { for: "description" }, [
                                _createTextVNode("Description"),
                                _createElementVNode("span", { class: "req-asterisk" }, "*")
                            ], -1)),
                            _createElementVNode("div", _hoisted_9, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    name: "description",
                                    id: "description",
                                    required: "",
                                    "aria-required": "true",
                                    autocomplete: "off",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.report.data.description) = $event))
                                }, null, 512), [
                                    [_vModelText, _ctx.report.data.description]
                                ])
                            ]),
                            (_ctx.report.fieldHasErrors('description'))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.report.getFieldError('description')), 1))
                                : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.report.fieldHasErrors('display_limit') }])
                        }, [
                            _cache[23] || (_cache[23] = _createElementVNode("label", { for: "display_limit" }, [
                                _createTextVNode("Display Limit"),
                                _createElementVNode("span", { class: "req-asterisk" }, "*")
                            ], -1)),
                            _createElementVNode("div", _hoisted_11, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    name: "display_limit",
                                    id: "display_limit",
                                    required: "",
                                    "aria-required": "true",
                                    autocomplete: "off",
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.report.data.display_limit) = $event))
                                }, null, 512), [
                                    [_vModelText, _ctx.report.data.display_limit]
                                ])
                            ]),
                            (_ctx.report.fieldHasErrors('display_limit'))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.report.getFieldError('display_limit')), 1))
                                : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.report.fieldHasErrors('show_data') }])
                        }, [
                            _createElementVNode("div", _hoisted_13, [
                                _withDirectives(_createElementVNode("input", {
                                    id: "show_data",
                                    name: "show_data",
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.report.data.show_data) = $event))
                                }, null, 512), [
                                    [_vModelCheckbox, _ctx.report.data.show_data]
                                ]),
                                _cache[24] || (_cache[24] = _createElementVNode("label", {
                                    for: "show_data",
                                    class: "ml-2 block text-sm text-slate-900"
                                }, "Display Report Data", -1))
                            ]),
                            _cache[25] || (_cache[25] = _createElementVNode("small", null, " Should this report display the result data when viewing the report. ", -1)),
                            (_ctx.report.fieldHasErrors('show_data'))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.report.getFieldError('show_data')), 1))
                                : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.report.fieldHasErrors('show_totals') }])
                        }, [
                            _createElementVNode("div", _hoisted_15, [
                                _withDirectives(_createElementVNode("input", {
                                    id: "show_totals",
                                    name: "show_totals",
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.report.data.show_totals) = $event))
                                }, null, 512), [
                                    [_vModelCheckbox, _ctx.report.data.show_totals]
                                ]),
                                _cache[26] || (_cache[26] = _createElementVNode("label", {
                                    for: "show_totals",
                                    class: "ml-2 block text-sm text-slate-900"
                                }, "Display Report Totals", -1))
                            ]),
                            _cache[27] || (_cache[27] = _createElementVNode("small", null, " Should this report display the result totals when viewing the report. ", -1)),
                            (_ctx.report.fieldHasErrors('show_totals'))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.report.getFieldError('show_totals')), 1))
                                : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.report.fieldHasErrors('admin_only') }])
                        }, [
                            _createElementVNode("div", _hoisted_17, [
                                _withDirectives(_createElementVNode("input", {
                                    id: "admin_only",
                                    name: "admin_only",
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.report.data.admin_only) = $event))
                                }, null, 512), [
                                    [_vModelCheckbox, _ctx.report.data.admin_only]
                                ]),
                                _cache[28] || (_cache[28] = _createElementVNode("label", {
                                    for: "admin_only",
                                    class: "ml-2 block text-sm text-slate-900"
                                }, "Admin Only", -1))
                            ]),
                            _cache[29] || (_cache[29] = _createElementVNode("small", null, " Should this report only be visible to admins. ", -1)),
                            (_ctx.report.fieldHasErrors('admin_only'))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.report.getFieldError('admin_only')), 1))
                                : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.report.fieldHasErrors('active') }])
                        }, [
                            _createElementVNode("div", _hoisted_19, [
                                _withDirectives(_createElementVNode("input", {
                                    id: "active",
                                    name: "active",
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.report.data.active) = $event))
                                }, null, 512), [
                                    [_vModelCheckbox, _ctx.report.data.active]
                                ]),
                                _cache[30] || (_cache[30] = _createElementVNode("label", {
                                    for: "active",
                                    class: "ml-2 block text-sm text-slate-900"
                                }, "Active", -1))
                            ]),
                            (_ctx.report.fieldHasErrors('active'))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.report.getFieldError('active')), 1))
                                : _createCommentVNode("", true)
                        ], 2)
                    ])
                ]),
                _createElementVNode("section", _hoisted_21, [
                    _cache[36] || (_cache[36] = _createElementVNode("aside", null, [
                        _createElementVNode("h2", { class: "font-medium text-lg" }, "Middleware"),
                        _createElementVNode("p", null, " Middleware provides a way to automatically inject query conditions into a report or intercept a request to render a report. For example check that a user is authenticated to view the report or check that results shown are owned by the current user. ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "dark w-36",
                                onClick: _cache[9] || (_cache[9] = _withModifiers(($event) => (_ctx.report.addMiddleware()), ["prevent"]))
                            }, "Add Middleware")
                        ]),
                        (_ctx.report.hasMiddleware())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.data.middleware, (middleware, index) => {
                                    return (_openBlock(), _createElementBlock("div", null, [
                                        (middleware.deleted_at === null)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: _normalizeClass(["col-span-6 xl:col-span-2 py-4", { 'form-control-error': _ctx.report.fieldHasErrors(`middleware.${index}.middleware`) }])
                                            }, [
                                                _createElementVNode("label", {
                                                    for: `middleware[${index}]`
                                                }, [...(_cache[32] || (_cache[32] = [
                                                        _createTextVNode("Middleware", -1),
                                                        _createElementVNode("span", { class: "req-asterisk" }, "*", -1)
                                                    ]))], 8, _hoisted_25),
                                                _createElementVNode("div", _hoisted_26, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        name: `middleware[${index}]`,
                                                        id: `middleware[${index}]`,
                                                        required: "",
                                                        "aria-required": "true",
                                                        autocomplete: "off",
                                                        "onUpdate:modelValue": ($event) => ((_ctx.report.data.middleware[index].middleware) = $event)
                                                    }, [
                                                        _cache[33] || (_cache[33] = _createElementVNode("option", { value: null }, "Select Middleware", -1)),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.middleware, (item) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                value: item.value
                                                            }, _toDisplayString(item.name), 9, _hoisted_28));
                                                        }), 256))
                                                    ], 8, _hoisted_27), [
                                                        [_vModelSelect, _ctx.report.data.middleware[index].middleware]
                                                    ]),
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "error ml-4",
                                                        "aria-label": "Delete Middleware",
                                                        onClick: ($event) => (_ctx.report.removeMiddleware(index))
                                                    }, [
                                                        (_openBlock(), _createElementBlock("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            class: "h-5 w-5 font-medium",
                                                            fill: "none",
                                                            viewBox: "0 0 24 24",
                                                            stroke: "currentColor",
                                                            "stroke-width": "2",
                                                            focusable: "false",
                                                            "aria-labelledby": `middleware[${index}]`
                                                        }, [...(_cache[34] || (_cache[34] = [
                                                                _createElementVNode("title", null, "Delete", -1),
                                                                _createElementVNode("path", {
                                                                    "stroke-linecap": "round",
                                                                    "stroke-linejoin": "round",
                                                                    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                                                }, null, -1)
                                                            ]))], 8, _hoisted_30))
                                                    ], 8, _hoisted_29)
                                                ]),
                                                (_ctx.report.fieldHasErrors(`middleware.${index}.middleware`))
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(_ctx.report.getFieldError(`middleware.${index}.middleware`)), 1))
                                                    : _createCommentVNode("", true)
                                            ], 2))
                                            : _createCommentVNode("", true),
                                        (middleware.deleted_at === null)
                                            ? (_openBlock(), _createElementBlock("hr", _hoisted_32))
                                            : _createCommentVNode("", true)
                                    ]));
                                }), 256))
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_33, [...(_cache[35] || (_cache[35] = [
                                    _createElementVNode("div", { class: "no-results panel p-10 mt-4" }, [
                                        _createElementVNode("div", { class: "text-slate-200 my-6" }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                class: "h-16 w-16 mx-auto",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                stroke: "currentColor",
                                                role: "img",
                                                focusable: "false",
                                                "aria-labelledby": "no-middleware"
                                            }, [
                                                _createElementVNode("title", null, "No Middleware"),
                                                _createElementVNode("path", {
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "2",
                                                    d: "M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                                                })
                                            ])
                                        ]),
                                        _createElementVNode("h2", {
                                            id: "no-middleware",
                                            class: "text-slate-600 font-medium text-2xl text-center"
                                        }, "No Middleware"),
                                        _createElementVNode("p", { class: "text-center mt-4 text-sm text-slate-700" }, " This report does not have any middleware associated with it. ")
                                    ], -1)
                                ]))]))
                    ])
                ]),
                _createElementVNode("section", _hoisted_34, [
                    _cache[47] || (_cache[47] = _createElementVNode("aside", null, [
                        _createElementVNode("h2", { class: "font-medium text-lg" }, "Fields"),
                        _createElementVNode("p", null, " Report fields are the parameters passed to the report, these parameters are used to further refine rendered report data e.g. passing a start_date and end_date to limit results between two dates. ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "dark w-36",
                                onClick: _cache[10] || (_cache[10] = _withModifiers(($event) => (_ctx.report.addField()), ["prevent"]))
                            }, "Add Field")
                        ]),
                        (_ctx.report.hasFields())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.data.fields, (field, index) => {
                                    return (_openBlock(), _createElementBlock("div", null, [
                                        (field.deleted_at === null)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: _normalizeClass(["col-span-6 xl:col-span-2 py-4", { 'form-control-error': _ctx.report.fieldHasErrors(`fields.${index}.label`) }])
                                            }, [
                                                _createElementVNode("label", {
                                                    for: `field[label][${index}]`
                                                }, [...(_cache[37] || (_cache[37] = [
                                                        _createTextVNode("Field Label", -1),
                                                        _createElementVNode("span", { class: "req-asterisk" }, "*", -1)
                                                    ]))], 8, _hoisted_38),
                                                _createElementVNode("div", _hoisted_39, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        name: `field[label][${index}]`,
                                                        id: `field[label][${index}]`,
                                                        autocomplete: "off",
                                                        "onUpdate:modelValue": ($event) => ((_ctx.report.data.fields[index].label) = $event)
                                                    }, null, 8, _hoisted_40), [
                                                        [_vModelText, _ctx.report.data.fields[index].label]
                                                    ]),
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "error ml-4",
                                                        "aria-label": "Delete Field",
                                                        onClick: ($event) => (_ctx.report.removeField(index))
                                                    }, [
                                                        (_openBlock(), _createElementBlock("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            class: "h-5 w-5 font-medium",
                                                            fill: "none",
                                                            viewBox: "0 0 24 24",
                                                            stroke: "currentColor",
                                                            "stroke-width": "2",
                                                            focusable: "false",
                                                            "aria-labelledby": `field[label][${index}]`
                                                        }, [...(_cache[38] || (_cache[38] = [
                                                                _createElementVNode("title", null, "Delete", -1),
                                                                _createElementVNode("path", {
                                                                    "stroke-linecap": "round",
                                                                    "stroke-linejoin": "round",
                                                                    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                                                }, null, -1)
                                                            ]))], 8, _hoisted_42))
                                                    ], 8, _hoisted_41)
                                                ]),
                                                (_ctx.report.fieldHasErrors(`fields.${index}.label`))
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_43, _toDisplayString(_ctx.report.getFieldError(`fields.${index}.label`)), 1))
                                                    : _createCommentVNode("", true)
                                            ], 2))
                                            : _createCommentVNode("", true),
                                        (field.deleted_at === null)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                class: _normalizeClass(["col-span-6 xl:col-span-2 py-4", { 'form-control-error': _ctx.report.fieldHasErrors(`fields.${index}.alias`) }])
                                            }, [
                                                _createElementVNode("label", {
                                                    for: `field[alias][${index}]`
                                                }, [...(_cache[39] || (_cache[39] = [
                                                        _createTextVNode("Criteria Alias", -1),
                                                        _createElementVNode("span", { class: "req-asterisk" }, "*", -1)
                                                    ]))], 8, _hoisted_44),
                                                _createElementVNode("div", _hoisted_45, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        name: `field[alias][${index}]`,
                                                        id: `field[alias][${index}]`,
                                                        required: "",
                                                        "aria-required": "true",
                                                        autocomplete: "off",
                                                        "onUpdate:modelValue": ($event) => ((_ctx.report.data.fields[index].alias) = $event)
                                                    }, null, 8, _hoisted_46), [
                                                        [_vModelText, _ctx.report.data.fields[index].alias]
                                                    ])
                                                ]),
                                                (_ctx.report.fieldHasErrors(`fields.${index}.alias`))
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString(_ctx.report.getFieldError(`fields.${index}.alias`)), 1))
                                                    : _createCommentVNode("", true)
                                            ], 2))
                                            : _createCommentVNode("", true),
                                        (field.deleted_at === null)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 2,
                                                class: _normalizeClass(["col-span-6 xl:col-span-2 py-4", { 'form-control-error': _ctx.report.fieldHasErrors(`fields.${index}.type`) }])
                                            }, [
                                                _createElementVNode("label", {
                                                    for: `field[type][${index}]`
                                                }, [...(_cache[40] || (_cache[40] = [
                                                        _createTextVNode("Criteria Type", -1),
                                                        _createElementVNode("span", { class: "req-asterisk" }, "*", -1)
                                                    ]))], 8, _hoisted_48),
                                                _createElementVNode("div", _hoisted_49, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        name: `field[type][${index}]`,
                                                        id: `field[type][${index}]`,
                                                        required: "",
                                                        "aria-required": "true",
                                                        autocomplete: "off",
                                                        "onUpdate:modelValue": ($event) => ((_ctx.report.data.fields[index].type) = $event)
                                                    }, [
                                                        _cache[41] || (_cache[41] = _createElementVNode("option", { value: null }, "Select Field Type", -1)),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.field_types, (item) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                value: item.value
                                                            }, _toDisplayString(item.name), 9, _hoisted_51));
                                                        }), 256))
                                                    ], 8, _hoisted_50), [
                                                        [_vModelSelect, _ctx.report.data.fields[index].type]
                                                    ])
                                                ]),
                                                (_ctx.report.fieldHasErrors(`fields.${index}.type`))
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_52, _toDisplayString(_ctx.report.getFieldError(`fields.${index}.type`)), 1))
                                                    : _createCommentVNode("", true)
                                            ], 2))
                                            : _createCommentVNode("", true),
                                        (field.type === 'select')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                                (field.deleted_at === null)
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 0,
                                                        class: _normalizeClass(["col-span-6 xl:col-span-2 py-4", { 'form-control-error': _ctx.report.fieldHasErrors(`fields.${index}.model`) }])
                                                    }, [
                                                        _createElementVNode("label", {
                                                            for: `field[model][${index}]`
                                                        }, [...(_cache[42] || (_cache[42] = [
                                                                _createTextVNode("Criteria Model", -1),
                                                                _createElementVNode("span", { class: "req-asterisk" }, "*", -1)
                                                            ]))], 8, _hoisted_54),
                                                        _createElementVNode("div", _hoisted_55, [
                                                            _withDirectives(_createElementVNode("select", {
                                                                name: `field[model][${index}]`,
                                                                id: `field[model][${index}]`,
                                                                required: "",
                                                                "aria-required": "true",
                                                                autocomplete: "off",
                                                                "onUpdate:modelValue": ($event) => ((_ctx.report.data.fields[index].model) = $event)
                                                            }, [
                                                                _cache[43] || (_cache[43] = _createElementVNode("option", { value: null }, "Select Model", -1)),
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.models, (item) => {
                                                                    return (_openBlock(), _createElementBlock("option", {
                                                                        value: item.value
                                                                    }, _toDisplayString(item.name), 9, _hoisted_57));
                                                                }), 256))
                                                            ], 8, _hoisted_56), [
                                                                [_vModelSelect, _ctx.report.data.fields[index].model]
                                                            ])
                                                        ]),
                                                        (_ctx.report.fieldHasErrors(`fields.${index}.model`))
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_58, _toDisplayString(_ctx.report.getFieldError(`fields.${index}.model`)), 1))
                                                            : _createCommentVNode("", true)
                                                    ], 2))
                                                    : _createCommentVNode("", true),
                                                (field.deleted_at === null)
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 1,
                                                        class: _normalizeClass(["col-span-6 xl:col-span-2 py-4", { 'form-control-error': _ctx.report.fieldHasErrors(`fields.${index}.model_select_value`) }])
                                                    }, [
                                                        _createElementVNode("label", {
                                                            for: `field[model_select_name][${index}]`
                                                        }, [...(_cache[44] || (_cache[44] = [
                                                                _createTextVNode("Model Field Value", -1),
                                                                _createElementVNode("span", { class: "req-asterisk" }, "*", -1)
                                                            ]))], 8, _hoisted_59),
                                                        _createElementVNode("div", _hoisted_60, [
                                                            _withDirectives(_createElementVNode("input", {
                                                                type: "text",
                                                                name: `field[model_select_name][${index}]`,
                                                                id: `field[model_select_name][${index}]`,
                                                                required: "",
                                                                "aria-required": "true",
                                                                autocomplete: "off",
                                                                "onUpdate:modelValue": ($event) => ((_ctx.report.data.fields[index].model_select_value) = $event)
                                                            }, null, 8, _hoisted_61), [
                                                                [_vModelText, _ctx.report.data.fields[index].model_select_value]
                                                            ])
                                                        ]),
                                                        (_ctx.report.fieldHasErrors(`fields.${index}.model_select_value`))
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_62, _toDisplayString(_ctx.report.getFieldError(`fields.${index}.model_select_value`)), 1))
                                                            : _createCommentVNode("", true)
                                                    ], 2))
                                                    : _createCommentVNode("", true),
                                                (field.deleted_at === null)
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 2,
                                                        class: _normalizeClass(["col-span-6 xl:col-span-2 py-4", { 'form-control-error': _ctx.report.fieldHasErrors(`fields.${index}.model_select_name`) }])
                                                    }, [
                                                        _createElementVNode("label", {
                                                            for: `field[model_select_value][${index}]`
                                                        }, [...(_cache[45] || (_cache[45] = [
                                                                _createTextVNode("Model Field Name", -1),
                                                                _createElementVNode("span", { class: "req-asterisk" }, "*", -1)
                                                            ]))], 8, _hoisted_63),
                                                        _createElementVNode("div", _hoisted_64, [
                                                            _withDirectives(_createElementVNode("input", {
                                                                type: "text",
                                                                name: `field[model_select_value][${index}]`,
                                                                id: `field[model_select_value][${index}]`,
                                                                required: "",
                                                                "aria-required": "true",
                                                                autocomplete: "off",
                                                                "onUpdate:modelValue": ($event) => ((_ctx.report.data.fields[index].model_select_name) = $event)
                                                            }, null, 8, _hoisted_65), [
                                                                [_vModelText, _ctx.report.data.fields[index].model_select_name]
                                                            ])
                                                        ]),
                                                        (_ctx.report.fieldHasErrors(`fields.${index}.model_select_name`))
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_66, _toDisplayString(_ctx.report.getFieldError(`fields.${index}.model_select_name`)), 1))
                                                            : _createCommentVNode("", true)
                                                    ], 2))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (field.deleted_at === null)
                                            ? (_openBlock(), _createElementBlock("hr", _hoisted_67))
                                            : _createCommentVNode("", true)
                                    ]));
                                }), 256))
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_68, [...(_cache[46] || (_cache[46] = [
                                    _createElementVNode("div", { class: "no-results panel p-10 mt-4" }, [
                                        _createElementVNode("div", { class: "text-slate-200 my-6" }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                class: "h-16 w-16 mx-auto",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                stroke: "currentColor",
                                                "stroke-width": "2",
                                                role: "img",
                                                focusable: "false",
                                                "aria-labelledby": "no-fields"
                                            }, [
                                                _createElementVNode("title", null, "No Fields"),
                                                _createElementVNode("path", {
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    d: "M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                                                })
                                            ])
                                        ]),
                                        _createElementVNode("h2", {
                                            id: "no-fields",
                                            class: "text-slate-600 font-medium text-2xl text-center"
                                        }, "No Fields"),
                                        _createElementVNode("p", { class: "text-center mt-4 text-sm text-slate-700" }, " This report does not have any fields associated with it. ")
                                    ], -1)
                                ]))]))
                    ])
                ]),
                _createElementVNode("section", _hoisted_69, [
                    _cache[55] || (_cache[55] = _createElementVNode("aside", null, [
                        _createElementVNode("h2", { class: "font-medium text-lg" }, "Columns"),
                        _createElementVNode("p", null, " Add some columns to the report structure, columns are the table head items in the report. ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("div", _hoisted_71, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "dark w-36",
                                onClick: _cache[11] || (_cache[11] = _withModifiers(($event) => (_ctx.report.addSelect()), ["prevent"]))
                            }, "Add Column")
                        ]),
                        (_ctx.report.hasSelects())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.data.selects, (select, index) => {
                                    return (_openBlock(), _createElementBlock("div", null, [
                                        (select.deleted_at === null)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: _normalizeClass(["col-span-6 xl:col-span-2 py-4", { 'form-control-error': _ctx.report.fieldHasErrors(`selects.${index}.type`) }])
                                            }, [
                                                _createElementVNode("label", {
                                                    for: `select[type][${index}]`
                                                }, [...(_cache[48] || (_cache[48] = [
                                                        _createTextVNode("Column Type", -1),
                                                        _createElementVNode("span", { class: "req-asterisk" }, "*", -1)
                                                    ]))], 8, _hoisted_73),
                                                _createElementVNode("div", _hoisted_74, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        name: `select[type][${index}]`,
                                                        id: `select[type][${index}]`,
                                                        autocomplete: "off",
                                                        "onUpdate:modelValue": ($event) => ((_ctx.report.data.selects[index].type) = $event)
                                                    }, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.data_types, (item) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                value: item.value
                                                            }, _toDisplayString(item.name), 9, _hoisted_76));
                                                        }), 256))
                                                    ], 8, _hoisted_75), [
                                                        [_vModelSelect, _ctx.report.data.selects[index].type]
                                                    ]),
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: _normalizeClass(["ml-4", { 'light': select.column_order === 1, 'dark': select.column_order !== 1 }]),
                                                        "aria-label": "Move Up",
                                                        disabled: select.column_order === 1,
                                                        onClick: ($event) => (_ctx.report.moveSelectUp(index))
                                                    }, [
                                                        (_openBlock(), _createElementBlock("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            class: "h-5 w-5 font-medium",
                                                            fill: "none",
                                                            viewBox: "0 0 24 24",
                                                            stroke: "currentColor",
                                                            "stroke-width": "2",
                                                            focusable: "false",
                                                            "aria-labelledby": `select[type][${index}]`
                                                        }, [...(_cache[49] || (_cache[49] = [
                                                                _createElementVNode("title", null, "Move Up", -1),
                                                                _createElementVNode("path", {
                                                                    "stroke-linecap": "round",
                                                                    "stroke-linejoin": "round",
                                                                    d: "M9 11l3-3m0 0l3 3m-3-3v8m0-13a9 9 0 110 18 9 9 0 010-18z"
                                                                }, null, -1)
                                                            ]))], 8, _hoisted_78))
                                                    ], 10, _hoisted_77),
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: _normalizeClass(["ml-2", { 'light': select.column_order === _ctx.report.data.selects.length, 'dark': select.column_order !== _ctx.report.data.selects.length }]),
                                                        "aria-label": "Move Down",
                                                        disabled: select.column_order === _ctx.report.data.selects.length,
                                                        onClick: ($event) => (_ctx.report.moveSelectDown(index))
                                                    }, [
                                                        (_openBlock(), _createElementBlock("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            class: "h-5 w-5 font-medium",
                                                            fill: "none",
                                                            viewBox: "0 0 24 24",
                                                            stroke: "currentColor",
                                                            "stroke-width": "2",
                                                            focusable: "false",
                                                            "aria-labelledby": `select[type][${index}]`
                                                        }, [...(_cache[50] || (_cache[50] = [
                                                                _createElementVNode("title", null, "Move Down", -1),
                                                                _createElementVNode("path", {
                                                                    "stroke-linecap": "round",
                                                                    "stroke-linejoin": "round",
                                                                    d: "M15 13l-3 3m0 0l-3-3m3 3V8m0 13a9 9 0 110-18 9 9 0 010 18z"
                                                                }, null, -1)
                                                            ]))], 8, _hoisted_80))
                                                    ], 10, _hoisted_79),
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "error ml-2",
                                                        "aria-label": "Delete Field",
                                                        onClick: ($event) => (_ctx.report.removeSelect(index))
                                                    }, [
                                                        (_openBlock(), _createElementBlock("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            class: "h-5 w-5 font-medium",
                                                            fill: "none",
                                                            viewBox: "0 0 24 24",
                                                            stroke: "currentColor",
                                                            "stroke-width": "2",
                                                            focusable: "false",
                                                            "aria-labelledby": `select[type][${index}]`
                                                        }, [...(_cache[51] || (_cache[51] = [
                                                                _createElementVNode("title", null, "Delete", -1),
                                                                _createElementVNode("path", {
                                                                    "stroke-linecap": "round",
                                                                    "stroke-linejoin": "round",
                                                                    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                                                }, null, -1)
                                                            ]))], 8, _hoisted_82))
                                                    ], 8, _hoisted_81)
                                                ]),
                                                (_ctx.report.fieldHasErrors(`selects.${index}.type`))
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_83, _toDisplayString(_ctx.report.getFieldError(`selects.${index}.type`)), 1))
                                                    : _createCommentVNode("", true)
                                            ], 2))
                                            : _createCommentVNode("", true),
                                        (select.deleted_at === null)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                class: _normalizeClass(["col-span-6 xl:col-span-2 py-4", { 'form-control-error': _ctx.report.fieldHasErrors(`selects.${index}.column`) }])
                                            }, [
                                                _createElementVNode("label", {
                                                    for: `select[column][${index}]`
                                                }, [...(_cache[52] || (_cache[52] = [
                                                        _createTextVNode("Select Column", -1),
                                                        _createElementVNode("span", { class: "req-asterisk" }, "*", -1)
                                                    ]))], 8, _hoisted_84),
                                                _createElementVNode("div", _hoisted_85, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        name: `select[column][${index}]`,
                                                        id: `select[column][${index}]`,
                                                        required: "",
                                                        "aria-required": "true",
                                                        autocomplete: "off",
                                                        "onUpdate:modelValue": ($event) => ((_ctx.report.data.selects[index].column) = $event)
                                                    }, null, 8, _hoisted_86), [
                                                        [_vModelText, _ctx.report.data.selects[index].column]
                                                    ])
                                                ]),
                                                (_ctx.report.fieldHasErrors(`selects.${index}.column`))
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_87, _toDisplayString(_ctx.report.getFieldError(`selects.${index}.column`)), 1))
                                                    : _createCommentVNode("", true)
                                            ], 2))
                                            : _createCommentVNode("", true),
                                        (select.deleted_at === null)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 2,
                                                class: _normalizeClass(["col-span-6 xl:col-span-2 py-4", { 'form-control-error': _ctx.report.fieldHasErrors(`selects.${index}.alias`) }])
                                            }, [
                                                _createElementVNode("label", {
                                                    for: `select[alias][${index}]`
                                                }, [...(_cache[53] || (_cache[53] = [
                                                        _createTextVNode("Select Alias", -1),
                                                        _createElementVNode("span", { class: "req-asterisk" }, "*", -1)
                                                    ]))], 8, _hoisted_88),
                                                _createElementVNode("div", _hoisted_89, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        name: `select[alias][${index}]`,
                                                        id: `select[alias][${index}]`,
                                                        required: "",
                                                        "aria-required": "true",
                                                        autocomplete: "off",
                                                        "onUpdate:modelValue": ($event) => ((_ctx.report.data.selects[index].alias) = $event)
                                                    }, null, 8, _hoisted_90), [
                                                        [_vModelText, _ctx.report.data.selects[index].alias]
                                                    ])
                                                ]),
                                                (_ctx.report.fieldHasErrors(`selects.${index}.alias`))
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_91, _toDisplayString(_ctx.report.getFieldError(`selects.${index}.alias`)), 1))
                                                    : _createCommentVNode("", true)
                                            ], 2))
                                            : _createCommentVNode("", true),
                                        (select.deleted_at === null)
                                            ? (_openBlock(), _createElementBlock("hr", _hoisted_92))
                                            : _createCommentVNode("", true)
                                    ]));
                                }), 256))
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_93, [...(_cache[54] || (_cache[54] = [
                                    _createElementVNode("div", { class: "no-results panel p-10 mt-4" }, [
                                        _createElementVNode("div", { class: "text-slate-200 my-6" }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                class: "h-12 w-12 mx-auto",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                stroke: "currentColor",
                                                role: "img",
                                                focusable: "false",
                                                "aria-labelledby": "no-columns"
                                            }, [
                                                _createElementVNode("title", null, "No Columns"),
                                                _createElementVNode("path", {
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "2",
                                                    d: "M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2"
                                                })
                                            ])
                                        ]),
                                        _createElementVNode("h2", {
                                            id: "no-columns",
                                            class: "text-slate-600 font-medium text-2xl text-center"
                                        }, "No Columns"),
                                        _createElementVNode("p", { class: "text-center mt-4 text-sm text-slate-700" }, " This report does not have any columns associated with it. ")
                                    ], -1)
                                ]))]))
                    ])
                ]),
                _createElementVNode("section", _hoisted_94, [
                    _cache[57] || (_cache[57] = _createElementVNode("aside", null, [
                        _createElementVNode("h2", { class: "font-medium text-lg" }, "Table (from)"),
                        _createElementVNode("p", null, " Select the primary table the report will be querying. ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_95, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.report.fieldHasErrors('table') }])
                        }, [
                            _cache[56] || (_cache[56] = _createElementVNode("label", { for: "table" }, [
                                _createTextVNode("Table"),
                                _createElementVNode("span", { class: "req-asterisk" }, "*")
                            ], -1)),
                            _createElementVNode("div", _hoisted_96, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    name: "table",
                                    id: "table",
                                    required: "",
                                    "aria-required": "true",
                                    autocomplete: "off",
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.report.data.table) = $event))
                                }, null, 512), [
                                    [_vModelText, _ctx.report.data.table]
                                ])
                            ]),
                            (_ctx.report.fieldHasErrors('table'))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_97, _toDisplayString(_ctx.report.getFieldError('table')), 1))
                                : _createCommentVNode("", true)
                        ], 2)
                    ])
                ]),
                _createElementVNode("section", _hoisted_98, [
                    _cache[65] || (_cache[65] = _createElementVNode("aside", null, [
                        _createElementVNode("h2", { class: "font-medium text-lg" }, "Joins"),
                        _createElementVNode("p", null, " Join other tables through the primary table or joined tables. ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_99, [
                        _createElementVNode("div", _hoisted_100, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "dark w-36",
                                onClick: _cache[13] || (_cache[13] = _withModifiers(($event) => (_ctx.report.addJoin()), ["prevent"]))
                            }, "Add Join")
                        ]),
                        (_ctx.report.hasJoins())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.data.joins, (join, index) => {
                                    return (_openBlock(), _createElementBlock("div", null, [
                                        (join.deleted_at === null)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: _normalizeClass(["col-span-6 xl:col-span-2 py-4", { 'form-control-error': _ctx.report.fieldHasErrors(`joins.${index}.type`) }])
                                            }, [
                                                _createElementVNode("label", {
                                                    for: `join[type][${index}]`
                                                }, [...(_cache[58] || (_cache[58] = [
                                                        _createTextVNode("Join Type", -1),
                                                        _createElementVNode("span", { class: "req-asterisk" }, "*", -1)
                                                    ]))], 8, _hoisted_102),
                                                _createElementVNode("div", _hoisted_103, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        name: `join[type][${index}]`,
                                                        id: `join[type][${index}]`,
                                                        autocomplete: "off",
                                                        "onUpdate:modelValue": ($event) => ((_ctx.report.data.joins[index].type) = $event)
                                                    }, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.join_types, (item) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                value: item.value
                                                            }, _toDisplayString(item.name), 9, _hoisted_105));
                                                        }), 256))
                                                    ], 8, _hoisted_104), [
                                                        [_vModelSelect, _ctx.report.data.joins[index].type]
                                                    ]),
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "error ml-4",
                                                        "aria-label": "Delete Field",
                                                        onClick: ($event) => (_ctx.report.removeJoin(index))
                                                    }, [
                                                        (_openBlock(), _createElementBlock("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            class: "h-5 w-5 font-medium",
                                                            fill: "none",
                                                            viewBox: "0 0 24 24",
                                                            stroke: "currentColor",
                                                            "stroke-width": "2",
                                                            focusable: "false",
                                                            "aria-labelledby": `join[type][${index}]`
                                                        }, [...(_cache[59] || (_cache[59] = [
                                                                _createElementVNode("title", null, "Delete", -1),
                                                                _createElementVNode("path", {
                                                                    "stroke-linecap": "round",
                                                                    "stroke-linejoin": "round",
                                                                    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                                                }, null, -1)
                                                            ]))], 8, _hoisted_107))
                                                    ], 8, _hoisted_106)
                                                ]),
                                                (_ctx.report.fieldHasErrors(`joins.${index}.type`))
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_108, _toDisplayString(_ctx.report.getFieldError(`joins.${index}.type`)), 1))
                                                    : _createCommentVNode("", true)
                                            ], 2))
                                            : _createCommentVNode("", true),
                                        (join.deleted_at === null)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                class: _normalizeClass(["col-span-6 xl:col-span-2 py-4", { 'form-control-error': _ctx.report.fieldHasErrors(`joins.${index}.table`) }])
                                            }, [
                                                _createElementVNode("label", {
                                                    for: `join[table][${index}]`
                                                }, [...(_cache[60] || (_cache[60] = [
                                                        _createTextVNode("Join Table", -1),
                                                        _createElementVNode("span", { class: "req-asterisk" }, "*", -1)
                                                    ]))], 8, _hoisted_109),
                                                _createElementVNode("div", _hoisted_110, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        name: `join[table][${index}]`,
                                                        id: `join[table][${index}]`,
                                                        required: "",
                                                        "aria-required": "true",
                                                        autocomplete: "off",
                                                        "onUpdate:modelValue": ($event) => ((_ctx.report.data.joins[index].table) = $event)
                                                    }, null, 8, _hoisted_111), [
                                                        [_vModelText, _ctx.report.data.joins[index].table]
                                                    ])
                                                ]),
                                                (_ctx.report.fieldHasErrors(`joins.${index}.table`))
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_112, _toDisplayString(_ctx.report.getFieldError(`joins.${index}.table`)), 1))
                                                    : _createCommentVNode("", true)
                                            ], 2))
                                            : _createCommentVNode("", true),
                                        (join.deleted_at === null)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 2,
                                                class: _normalizeClass(["col-span-6 xl:col-span-2 py-4", { 'form-control-error': _ctx.report.fieldHasErrors(`joins.${index}.first`) }])
                                            }, [
                                                _createElementVNode("label", {
                                                    for: `join[first][${index}]`
                                                }, [...(_cache[61] || (_cache[61] = [
                                                        _createTextVNode("Join Column # 1", -1),
                                                        _createElementVNode("span", { class: "req-asterisk" }, "*", -1)
                                                    ]))], 8, _hoisted_113),
                                                _createElementVNode("div", _hoisted_114, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        name: `join[first][${index}]`,
                                                        id: `join[first][${index}]`,
                                                        required: "",
                                                        "aria-required": "true",
                                                        autocomplete: "off",
                                                        "onUpdate:modelValue": ($event) => ((_ctx.report.data.joins[index].first) = $event)
                                                    }, null, 8, _hoisted_115), [
                                                        [_vModelText, _ctx.report.data.joins[index].first]
                                                    ])
                                                ]),
                                                (_ctx.report.fieldHasErrors(`joins.${index}.first`))
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_116, _toDisplayString(_ctx.report.getFieldError(`joins.${index}.first`)), 1))
                                                    : _createCommentVNode("", true)
                                            ], 2))
                                            : _createCommentVNode("", true),
                                        (join.deleted_at === null)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 3,
                                                class: _normalizeClass(["col-span-6 xl:col-span-2 py-4", { 'form-control-error': _ctx.report.fieldHasErrors(`joins.${index}.operator`) }])
                                            }, [
                                                _createElementVNode("label", {
                                                    for: `join[operator][${index}]`
                                                }, [...(_cache[62] || (_cache[62] = [
                                                        _createTextVNode("Join Operator", -1),
                                                        _createElementVNode("span", { class: "req-asterisk" }, "*", -1)
                                                    ]))], 8, _hoisted_117),
                                                _createElementVNode("div", _hoisted_118, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        name: `join[operator][${index}]`,
                                                        id: `join[operator][${index}]`,
                                                        required: "",
                                                        "aria-required": "true",
                                                        autocomplete: "off",
                                                        "onUpdate:modelValue": ($event) => ((_ctx.report.data.joins[index].operator) = $event)
                                                    }, null, 8, _hoisted_119), [
                                                        [_vModelText, _ctx.report.data.joins[index].operator]
                                                    ])
                                                ]),
                                                (_ctx.report.fieldHasErrors(`joins.${index}.operator`))
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_120, _toDisplayString(_ctx.report.getFieldError(`joins.${index}.operator`)), 1))
                                                    : _createCommentVNode("", true)
                                            ], 2))
                                            : _createCommentVNode("", true),
                                        (join.deleted_at === null)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 4,
                                                class: _normalizeClass(["col-span-6 xl:col-span-2 py-4", { 'form-control-error': _ctx.report.fieldHasErrors(`joins.${index}.second`) }])
                                            }, [
                                                _createElementVNode("label", {
                                                    for: `join[second][${index}]`
                                                }, [...(_cache[63] || (_cache[63] = [
                                                        _createTextVNode("Join Column # 2", -1),
                                                        _createElementVNode("span", { class: "req-asterisk" }, "*", -1)
                                                    ]))], 8, _hoisted_121),
                                                _createElementVNode("div", _hoisted_122, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        name: `join[second][${index}]`,
                                                        id: `join[second][${index}]`,
                                                        required: "",
                                                        "aria-required": "true",
                                                        autocomplete: "off",
                                                        "onUpdate:modelValue": ($event) => ((_ctx.report.data.joins[index].second) = $event)
                                                    }, null, 8, _hoisted_123), [
                                                        [_vModelText, _ctx.report.data.joins[index].second]
                                                    ])
                                                ]),
                                                (_ctx.report.fieldHasErrors(`joins.${index}.second`))
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_124, _toDisplayString(_ctx.report.getFieldError(`joins.${index}.second`)), 1))
                                                    : _createCommentVNode("", true)
                                            ], 2))
                                            : _createCommentVNode("", true),
                                        (join.deleted_at === null)
                                            ? (_openBlock(), _createElementBlock("hr", _hoisted_125))
                                            : _createCommentVNode("", true)
                                    ]));
                                }), 256))
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_126, [...(_cache[64] || (_cache[64] = [
                                    _createElementVNode("div", { class: "no-results panel p-10 mt-4" }, [
                                        _createElementVNode("div", { class: "text-slate-200 my-6" }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                class: "h-16 w-16 mx-auto",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                stroke: "currentColor",
                                                role: "img",
                                                focusable: "false",
                                                "aria-labelledby": "no-joins"
                                            }, [
                                                _createElementVNode("title", null, "No Joins"),
                                                _createElementVNode("path", {
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                                                })
                                            ])
                                        ]),
                                        _createElementVNode("h2", {
                                            id: "no-joins",
                                            class: "text-slate-600 font-medium text-2xl text-center"
                                        }, "No Joins"),
                                        _createElementVNode("p", { class: "text-center mt-4 text-sm text-slate-700" }, " This report does not have any joins associated with it. ")
                                    ], -1)
                                ]))]))
                    ])
                ]),
                _createElementVNode("section", _hoisted_127, [
                    _cache[67] || (_cache[67] = _createElementVNode("aside", null, [
                        _createElementVNode("h2", { class: "font-medium text-lg" }, "Where"),
                        _createElementVNode("p", null, [
                            _createTextVNode(" Columns on the primary table or any joined tables can be used in this section e.g. "),
                            _createElementVNode("span", { class: "text-xs font-medium bg-brand-50 p-1 text-brand-800" }, "users.active = 1"),
                            _createTextVNode(". Field parameters can be used by adding the criteria alias in curly braces e.g. "),
                            _createElementVNode("span", { class: "text-xs font-medium bg-brand-50 p-1 text-brand-800" }, "users.created_at >= {start_date}"),
                            _createTextVNode(". We recommend always appending the columns table to avoid ambiguous column names e.g. "),
                            _createElementVNode("span", { class: "text-xs font-medium bg-brand-50 p-1 text-brand-800" }, "users.id = 1 AND logs.id > 100")
                        ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_128, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.report.fieldHasErrors('where') }])
                        }, [
                            _cache[66] || (_cache[66] = _createElementVNode("label", { for: "where" }, "Where", -1)),
                            _createElementVNode("div", _hoisted_129, [
                                _withDirectives(_createElementVNode("textarea", {
                                    id: "where",
                                    name: "where",
                                    rows: "8",
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.report.data.where) = $event)),
                                    autocomplete: "off"
                                }, null, 512), [
                                    [_vModelText, _ctx.report.data.where]
                                ])
                            ]),
                            (_ctx.report.fieldHasErrors('where'))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_130, _toDisplayString(_ctx.report.getFieldError('where')), 1))
                                : _createCommentVNode("", true)
                        ], 2)
                    ])
                ]),
                _createElementVNode("section", _hoisted_131, [
                    _cache[74] || (_cache[74] = _createElementVNode("aside", null, [
                        _createElementVNode("h2", { class: "font-medium text-lg" }, "Sorting"),
                        _createElementVNode("p", null, " Sort you results. ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_132, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.report.fieldHasErrors('groupby') }])
                        }, [
                            _cache[68] || (_cache[68] = _createElementVNode("label", { for: "groupby" }, "Group By", -1)),
                            _createElementVNode("div", _hoisted_133, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    name: "groupby",
                                    id: "groupby",
                                    autocomplete: "off",
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.report.data.groupby) = $event))
                                }, null, 512), [
                                    [_vModelText, _ctx.report.data.groupby]
                                ])
                            ]),
                            _cache[69] || (_cache[69] = _createElementVNode("small", null, " e.g. users.role ", -1)),
                            (_ctx.report.fieldHasErrors('groupby'))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_134, _toDisplayString(_ctx.report.getFieldError('groupby')), 1))
                                : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.report.fieldHasErrors('having') }])
                        }, [
                            _cache[70] || (_cache[70] = _createElementVNode("label", { for: "having" }, "Having", -1)),
                            _createElementVNode("div", _hoisted_135, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    name: "having",
                                    id: "having",
                                    autocomplete: "off",
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.report.data.having) = $event))
                                }, null, 512), [
                                    [_vModelText, _ctx.report.data.having]
                                ])
                            ]),
                            _cache[71] || (_cache[71] = _createElementVNode("small", null, " e.g. users.id > 100 ", -1)),
                            (_ctx.report.fieldHasErrors('having'))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_136, _toDisplayString(_ctx.report.getFieldError('having')), 1))
                                : _createCommentVNode("", true)
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.report.fieldHasErrors('orderby') }])
                        }, [
                            _cache[72] || (_cache[72] = _createElementVNode("label", { for: "orderby" }, "Order By", -1)),
                            _createElementVNode("div", _hoisted_137, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    name: "orderby",
                                    id: "orderby",
                                    autocomplete: "off",
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_ctx.report.data.orderby) = $event))
                                }, null, 512), [
                                    [_vModelText, _ctx.report.data.orderby]
                                ])
                            ]),
                            _cache[73] || (_cache[73] = _createElementVNode("small", null, " e.g. users.created_at DESC ", -1)),
                            (_ctx.report.fieldHasErrors('orderby'))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_138, _toDisplayString(_ctx.report.getFieldError('orderby')), 1))
                                : _createCommentVNode("", true)
                        ], 2)
                    ])
                ]),
                _createElementVNode("div", _hoisted_139, [
                    _createElementVNode("div", _hoisted_140, [
                        (_ctx.report.successful())
                            ? (_openBlock(), _createElementBlock("p", _hoisted_141, _toDisplayString(_ctx.report.getSuccessMessage()), 1))
                            : _createCommentVNode("", true),
                        (_ctx.report.hasErrorOccurred())
                            ? (_openBlock(), _createElementBlock("p", _hoisted_142, _toDisplayString(_ctx.report.getErrorMessage()), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", null, [
                        _createElementVNode("button", {
                            type: "submit",
                            disabled: _ctx.report.isSubmitting(),
                            "aria-disabled": _ctx.report.isSubmitting()
                        }, [
                            _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_144, [...(_cache[75] || (_cache[75] = [
                                    _createElementVNode("circle", {
                                        class: "opacity-25",
                                        cx: "12",
                                        cy: "12",
                                        r: "10",
                                        stroke: "currentColor",
                                        "stroke-width": "4"
                                    }, null, -1),
                                    _createElementVNode("path", {
                                        class: "opacity-75",
                                        fill: "currentColor",
                                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                    }, null, -1)
                                ]))], 512)), [
                                [_vShow, _ctx.report.isSubmitting()]
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.submitName), 1)
                        ], 8, _hoisted_143)
                    ])
                ])
            ], 32))
            : (_openBlock(), _createBlock(_component_Loading, {
                key: 1,
                message: "Loading Report Creator"
            }))
    ]));
}
